angular.module('categoriesFilterApp', [])
    .controller('categoriesFilter.CategoriesFilterCtrl', ['$scope', '$location', 'othersService', function ($scope, $location, othersService) {
        var context = this;
        context.lastCategoryId = null;
        // load main categories only if = 0
        context.categoryId = angular.isDefined(context.categoryId) ? context.categoryId : null;
        context.filterType = angular.isDefined(context.filterType) ? context.filterType : null;
        context.baseUrl = angular.isDefined(context.baseUrl) ? context.baseUrl : null;
        context.requestFilters = angular.isDefined(context.requestFilters) ? context.requestFilters : {};
        context.relatedSeoData = angular.isDefined(context.relatedSeoData) ? context.relatedSeoData : null;
        context.onUpdateCallback = angular.isDefined(context.onUpdateCallback) ? context.onUpdateCallback : null;

        context.updateQueryString = function () {
            var search = $location.search();
            var queryParts = [];
            for (var filterKey in search) {
                if (filterKey == 'page' || filterKey == 'availabilityFilter' || filterKey == 'remoteType') { // skip pagination and some specific filters
                    continue;
                }
                queryParts.push(filterKey + "=" + search[filterKey]);
            }
            if (queryParts.length) {
                context.queryString = "?" + queryParts.join("&");
            } else {
                context.queryString = "";
            }
        };
        context.updateQueryString();


        $scope.$watch('filterController.categoryId', function (value) {
            if (context.lastCategoryId != context.categoryId) {
                context.lastCategoryId = context.categoryId;
                context.getSkillCategories();
            }
        });
        $scope.$watch('filterController.requestFilters', function (value) {
            context.getSkillCategories();
            context.updateQueryString();
        });

        //load detailed filter categories
        context.getSkillCategories = function () {
            context.categories = {items: null, allItems: null, fullView: null};
            if (context.categoryId !== null) {
                context.getSkillCategoriesPromise = othersService.getCategoriesWithCount(context.categoryId, context.filterType, context.requestFilters)
                    .then(function (categories) {
                        context.categories.allItems = categories.items;
                        context.categories.items = context.filterCategories(categories.items);
                        context.categories.breadcrumbs = categories.breadcrumbs;
                        context.categories.suggestions = categories.suggestions;
                        context.categories.parentCategory = categories.parentCategory;
                    });
            }
        };
        context.getSkillCategories();

        context.changeFilterCategory = function (category) {
            context.categoryId = category !== null ? category.id : null;
            context.getSkillCategories();
            if (context.onUpdateCallback !== null) {
                context.onUpdateCallback({categoryId: context.categoryId});
            }
        };

        context.getSkillUrl = function (item) {
            var url = context.baseUrl + "/" + item.urlAlias;
            if (context.relatedSeoData !== null && context.relatedSeoData.seoLocation) {
                url += "-" + context.relatedSeoData.seoLocation.urlAlias;
            }
            url += context.queryString;
            return url;
        };

        context.filterCategories = function (categories) {
            var filterImportantCategory = function (category) {
                if (category.parentId === null) { //main category filter
                    return category.count >= 1;
                } else { //subcategory filter
                    var limit = context.filterType == "project" ? 1 : 10;
                    return category.count >= limit;
                }
            };
            return categories.filter(filterImportantCategory);
        };
    }])

    .directive('categoriesFilter', ['$parse', function ($parse) {
        return {
            restrict: 'E',
            transclude: true,
            templateUrl: "../skills/categories-filter.tpl",
            controller: 'categoriesFilter.CategoriesFilterCtrl',
            controllerAs: 'filterController',
            bindToController: true,
            scope: {
                categoryId: '=categoryIdModel',
                filterType: '@',
                baseUrl: '@',
                requestFilters: '=',
                relatedSeoData: '=',
                onUpdateCallback: '&'
            }
        };
    }]);
